// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardFolderList {
  margin-bottom: 24px;
}
.DashboardFolderList .listWrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
  gap: 24px;
}
.DashboardFolderList.isListEmpty .listWrapper {
  grid-template-columns: 1fr;
}
.DashboardFolderList .createFolderButton {
  font-size: 12px;
  font-weight: 700;
  background-color: var(--color_neutral_200) !important;
  color: var(--color_neutral_800) !important;
  display: flex;
  column-gap: 8px;
  border-radius: 12px !important;
  min-height: 72px;
}
.DashboardFolderList .createFolderButton:hover {
  background-color: var(--color_primary_100) !important;
}
.DashboardFolderList .DashboardFolderListloadingWrapper {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
  gap: 24px;
  height: 72px;
  margin-top: 24px;
}
.DashboardFolderList .loadMoreSection {
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/dashboard-folder-list/dashboard-folder-list.styles.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACE;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EAAA,SAAA;AACJ;AAGI;EACE,0BAAA;AADN;AAKE;EACE,eAAA;EACA,gBAAA;EACA,qDAAA;EACA,0CAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;AAHJ;AAKI;EACE,qDAAA;AAHN;AAOE;EACE,WAAA;EACA,aAAA;EACA,qCAAA;EACA,cAAA;EAAA,SAAA;EACA,YAAA;EACA,gBAAA;AALJ;AAQE;EACE,aAAA;EACA,yBAAA;AANJ","sourcesContent":[".DashboardFolderList {\n  margin-bottom: 24px;\n\n  .listWrapper {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n  }\n\n  &.isListEmpty {\n    .listWrapper {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .createFolderButton {\n    font-size: 12px;\n    font-weight: 700;\n    background-color: var(--color_neutral_200) !important;\n    color: var(--color_neutral_800) !important;\n    display: flex;\n    column-gap: 8px;\n    border-radius: 12px !important;\n    min-height: 72px;\n\n    &:hover {\n      background-color: var(--color_primary_100) !important;\n    }\n  }\n\n  .DashboardFolderListloadingWrapper {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n    height: 72px;\n    margin-top: 24px;\n  }\n\n  .loadMoreSection {\n    display: flex;\n    justify-content: flex-end;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
